import { Fancybox } from "@fancyapps/ui";
import InfiniteMarquee from "vanilla-infinite-marquee";

import "./modules/Header";
import "./modules/Slider";
import "./modules/Tab";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/ProjectDetail";
import "./modules/Capability";

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$(function () {
	try {
		document.addEventListener("facetwp-loaded", function () {
			lazyLoadInstance.update();
		});
	} catch (error) {}

	const infiniteMarquee = new InfiniteMarquee({
		element: document.querySelector(".infinite-marquee"),
		speed: 100000,
		gap: "2rem",
	});

	addFirstColumnClass();
	$(window).resize(function () {
		addFirstColumnClass();
	});
});

function addFirstColumnClass() {
	const row = $(".row-computed");
	let currentTopPosition = null;

	row.find("> *")
		.removeClass("first-column")
		.each(function () {
			const itemTopPosition = $(this).position().top;

			if (
				currentTopPosition === null ||
				itemTopPosition > currentTopPosition
			) {
				currentTopPosition = itemTopPosition;
				$(this).addClass("first-column");
			}
		});
}
